import React, { useState, useCallback } from 'react';
import { Handle, Position } from 'reactflow';
import { Button, Chip } from '@mui/material';
import { TriggerSelector } from './TriggerSelector';

export const TriggerNode = ({ data, selected, id }) => {
  const [isSelectorOpen, setIsSelectorOpen] = useState(false);

  const handleTriggerSelect = useCallback((trigger) => {
    data.onChange?.({ triggerId: trigger.id, triggerName: trigger.name, triggerKey: trigger.key });
    setIsSelectorOpen(false);
  }, [data]);

  const handleTriggerRemove = useCallback(() => {
    data.onChange?.({ triggerId: null, triggerName: null, triggerKey: null });
  }, [data]);

  return (
    <div className="react-flow__node-default">
      <Handle
        type="target"
        position={Position.Left}
        style={{ 
          left: 0,
          top: 24,
          transform: 'translateY(-50%)'
        }}
      />
      
      <div className="condition-label">
        <label style={{ display: 'block' }}>Trigger</label>
      </div>

      <div style={{ padding: 20, paddingTop: 0 }}>
        {data.triggerId ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-start' }}>
            <Chip 
              label={data.triggerName} 
              onDelete={handleTriggerRemove}
              color="primary" 
              sx={{ maxWidth: '100%' }}
            />
            {data.triggerKey && (
              <Chip 
                label={data.triggerKey} 
                color="secondary" 
                size="small"
                variant="outlined"
                sx={{ maxWidth: '100%' }}
              />
            )}
          </div>
        ) : (
          <Button 
            variant="contained" 
            color="primary" 
            onClick={() => setIsSelectorOpen(true)}
          >
            Select trigger
          </Button>
        )}
      </div>

      <Handle
        type="source"
        position={Position.Right}
        id="true"
        style={{
          right: 0,
          top: '64%',
          transform: 'translateY(-50%)'
        }}
      />

      <TriggerSelector
        open={isSelectorOpen}
        onClose={() => setIsSelectorOpen(false)}
        onSelect={handleTriggerSelect}
      />
    </div>
  );
};